"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.siteReducer = exports.clearCurrentSite = exports.setCurrentSite = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    current: null,
};
// Holds the active site config for the current browsing session. Populated
// by the useSiteConfig / useSiteConfigBySlug hooks when a site loads, so
// non-React surfaces (notably the FaceTec sample-app controller) can read
// tenant branding without threading siteConfig through React props.
var siteSlice = (0, toolkit_1.createSlice)({
    name: "site",
    initialState: initialState,
    reducers: {
        setCurrentSite: function (state, action) {
            state.current = action.payload;
        },
        clearCurrentSite: function (state) {
            state.current = null;
        },
    },
});
exports.setCurrentSite = (_a = siteSlice.actions, _a.setCurrentSite), exports.clearCurrentSite = _a.clearCurrentSite;
exports.siteReducer = siteSlice.reducer;
